import { Link } from 'react-router-dom';
import { PageTransition, FadeIn } from '../components/layout';
import { ChevronRight } from 'lucide-react';

export default function PolitiqueConfidentialitePage() {
  return (
    <PageTransition>
      <section className="pt-32 pb-8 px-6 bg-gradient-to-b from-[var(--champagne)]/30 to-white">
        <div className="max-w-[800px] mx-auto text-center">
          <h1 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-light mb-4 text-[var(--charcoal)]">
            Politique de Confidentialité
          </h1>
        </div>
      </section>

      <div className="bg-white py-4 border-b border-[var(--champagne)]">
        <div className="max-w-[1400px] mx-auto px-6">
          <nav className="flex items-center gap-2 text-sm text-[var(--charcoal)]/60">
            <Link to="/" className="hover:text-[var(--gold)] transition-colors">Accueil</Link>
            <ChevronRight size={14} />
            <span className="text-[var(--charcoal)]">Politique de Confidentialité</span>
          </nav>
        </div>
      </div>

      <section className="py-16 px-6" data-testid="confidentialite-content">
        <div className="max-w-[800px] mx-auto">
          <FadeIn>
            <div className="prose prose-lg max-w-none text-[var(--charcoal)]/70">
              <h2 className="font-['Cormorant_Garamond'] text-2xl text-[var(--charcoal)] mb-4">Collecte des données</h2>
              <p>
                Nous collectons uniquement les données personnelles nécessaires au traitement de vos demandes : 
                nom, prénom, email, téléphone, et les informations relatives à vos commandes.
              </p>

              <h2 className="font-['Cormorant_Garamond'] text-2xl text-[var(--charcoal)] mt-8 mb-4">Utilisation des données</h2>
              <p>
                Vos données sont utilisées exclusivement pour :<br />
                - La gestion de vos rendez-vous et commandes<br />
                - La communication relative à nos services<br />
                - L'amélioration de nos prestations
              </p>

              <h2 className="font-['Cormorant_Garamond'] text-2xl text-[var(--charcoal)] mt-8 mb-4">Conservation des données</h2>
              <p>
                Vos données personnelles sont conservées pendant une durée de 3 ans à compter de votre dernière interaction avec nous.
              </p>

              <h2 className="font-['Cormorant_Garamond'] text-2xl text-[var(--charcoal)] mt-8 mb-4">Vos droits</h2>
              <p>
                Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, de suppression et de portabilité de vos données. 
                Pour exercer ces droits, contactez-nous à : contact@madamedsrs.fr
              </p>

              <h2 className="font-['Cormorant_Garamond'] text-2xl text-[var(--charcoal)] mt-8 mb-4">Cookies</h2>
              <p>
                Ce site utilise des cookies techniques essentiels au fonctionnement du site. 
                Aucun cookie de tracking ou publicitaire n'est utilisé.
              </p>
            </div>
          </FadeIn>
        </div>
      </section>
    </PageTransition>
  );
}
